// extracted by css-extract-rspack-plugin
export default {"buttonTabDropDownWrapper":"ButtonTabDropdown-module__buttonTabDropDownWrapper___xpCLM","menuWrapper":"ButtonTabDropdown-module__menuWrapper___bdO2S"};